module.exports = __webpack_public_path__ + "6a6338762a7f403ed1a2aee1838854e4.fbx";